<template>

  <div class="gridelement formsectioncompound">
    <div class="wm-field-label">
      <label>{{ $t(label) }}</label>
    </div>
    <div class="jq_gridcontentarea">
      <div v-show="!showEngravedIdPaste" class="wm-field small-3 columns">
        <engraved-id-part v-model="engravedId1"
                          :part="1"
                          :disabled="false"
                          :readonly="false"
                          :show-validation-errors="showPartValidationErrors"
                          :parent-error="$v.$error"
                          @paste="onPaste"/>
      </div>
      <div v-show="!showEngravedIdPaste" class="wm-field small-3 columns">
        <engraved-id-part v-model="engravedId2"
                          :part="2"
                          :validate-on-blur="validateOnBlur"
                          :show-validation-errors="showPartValidationErrors"
                          :parent-error="$v.$error"
                          @paste="onPaste"/>
      </div>
      <div v-show="!showEngravedIdPaste" class="wm-field small-3 columns">
        <engraved-id-part v-model="engravedId3"
                          :part="3"
                          :validate-on-blur="validateOnBlur"
                          :parent-error="$v.$error"
                          :show-validation-errors="showPartValidationErrors"
                          @previous="jump('engravedId_1')"
                          @paste="onPaste"/>
      </div>
      <div v-show="!showEngravedIdPaste" class="wm-field small-3 columns">
        <engraved-id-part v-model="engravedId4"
                          :part="4"
                          :validate-on-blur="validateOnBlur"
                          :parent-error="$v.$error"
                          :show-validation-errors="showPartValidationErrors"
                          @previous="jump('engravedId_2')"
                          @paste="onPaste"/>
      </div>
      <div v-show="showEngravedIdPaste" class="wm-field columns">
        <div class="wm-field-input">
          <input id="engravedId_paste"
                 v-model="engravedIdPaste"
                 title="engravedIdPaste"
                 type="text"
                 class="multitext card-number">
        </div>
      </div>
    </div>
    <ul v-if="$v.$error" class="ui-state-error errors" role="alert" aria-atomic="true" aria-live="polite">
      <li v-if="!$v.required">{{ $t('engraved-id.$v.required') }}</li>
      <li v-if="!$v.minLength">{{ $t('engraved-id.$v.required') }}</li>
      <li v-if="!$v.regex">{{ $t('engraved-id.$v.regex') }}</li>
      <li v-if="!$v.hasConfiguration">
        {{ $t('engraved-id.$v.no-configuration') }}
      </li>
      <li v-if="!$v.errorCode && $v.required && $v.minLength && $v.regex && $v.hasConfiguration">
        {{ $t(`engraved-id.$v.${$v.$params.errorCode.code}`) }}
      </li>
    </ul>
  </div>
</template>

<script>
import EngravedIdPart from './EngravedIdPart'

export default {
  components: {
    EngravedIdPart
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    $v: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: 'engraved-id.label'
    },
    showPartValidationErrors: {
      type: Boolean,
      default: true
    },
    validateOnBlur: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      engravedId1: '3528',
      engravedId2: '',
      engravedId3: '',
      engravedId4: '',
      engravedIdPaste: '',
      showEngravedIdPaste: false
    }
  },
  watch: {
    engravedId1: function (value) {
      if (value.length === 4) this.jump('engravedId_1')
      this.updateEngravedId()
    },
    engravedId2: function (value) {
      if (value.length === 4) this.jump('engravedId_2')
      this.updateEngravedId()
    },
    engravedId3: function (value) {
      if (value.length === 4) this.jump('engravedId_3')
      this.updateEngravedId()
    },
    engravedId4: function () {
      this.updateEngravedId()
    },
    value () {
      this.splitEngravedId(this.value)
    }
  },
  mounted: function () {
    this.splitEngravedId(this.value)
  },
  methods: {
    jump: function (id) {
      document.getElementById(id).focus()
    },
    updateEngravedId: function () {
      this.$emit('input', this.engravedId1 + this.engravedId2 + this.engravedId3 + this.engravedId4)
    },
    splitEngravedId: function (value) {
      if (value === '') {
        this.engravedId1 = ''
        this.engravedId2 = ''
        this.engravedId3 = ''
        this.engravedId4 = ''
      }
      this.engravedId1 = value.slice(0, 4)
      this.engravedId2 = value.slice(4, 8)
      this.engravedId3 = value.slice(8, 12)
      this.engravedId4 = value.slice(12, 16)
    },
    onPaste: function (e) {
      e.preventDefault()
      const engravedIdPasteField = document.getElementById('engravedId_paste')
      const clipboardData = (e.clipboardData || window.clipboardData).getData('text')

      this.showEngravedIdPaste = true
      this.engravedIdPaste = clipboardData

      const blurEventListener = () => {
        this.showEngravedIdPaste = false
        this.splitEngravedId(this.engravedIdPaste.replace(/[^0-9]/g, ''))

        engravedIdPasteField.removeEventListener('blur', blurEventListener)
      }

      setTimeout(() => engravedIdPasteField.focus(), 10)
      engravedIdPasteField.addEventListener('blur', blurEventListener)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/EngravedId.vue